import FeedMessage from "../Feed/FeedMessage";

const UserNewsfeed = ({ newsfeeds }) => {
  return (
    <div>
      <div className="text-3xl font-semibold mb-12">News feed</div>
      {newsfeeds.map((feed, index) => (
        <FeedMessage key={index} {...feed} postId={feed._id} />
      ))}
    </div>
  );
};

export default UserNewsfeed;
